import React, {FC} from "react";

import closeIcon from '../assets/close.png';

interface ControlsProps {
    title: string;
    onHide: () => void;
}

const Controls: FC<ControlsProps> = ({
                                         title,
                                         onHide,
                                         children
                                     }) => {
    return (
        <div className="controls">
            <img src={closeIcon} alt="Hide controls" className="controls__hide-icon" onClick={onHide}/>
            <h5>{title}</h5>
            {children}
        </div>
    );
};

export default Controls;